import { Component, Prop, Vue } from 'vue-property-decorator'
import { genId } from '@/helpers/gen-id'

import CardDeadline from '@/components/CardDeadline/index.vue'
import CardEmailLog from './CardEmailLog/index.vue'
import CardAuditoria from './CardAuditoria/index.vue'

@Component({
	components: {
		CardDeadline,
		CardEmailLog,
		CardAuditoria,
	},
})
export default class YearMonthList extends Vue {
	@Prop() readonly tasks

	today = new Date().toISOString().split('T')[0]

	// get years() {
	// 	const uniqueYears = new Set()
	// 	this.tasks.forEach((task) => {
	// 		// date format = 'YYYY-MM-DD'
	// 		uniqueYears.add(task.date.split('-')[0])
	// 	})

	// 	return ([...uniqueYears] as string[]).sort(
	// 		(a, b) => parseInt(a) - parseInt(b),
	// 	)
	// }

	/**
	 * exemplo:
	 * [
	 *   {
	 *     year: '2020',
	 *     htmlId: '',
	 *     months: [
	 *       {
	 *         month: 'Janeiro',
	 *         htmlId: '',
	 *         deadlines: [
	 *           {deadline}
	 *         ]
	 *       }
	 *     ]
	 *   }
	 * ]
	 **/
	// get structuredTasks() {
	// 	const monthNames = [
	// 		'Janeiro',
	// 		'Fevereiro',
	// 		'Março',
	// 		'Abril',
	// 		'Maio',
	// 		'Junho',
	// 		'Julho',
	// 		'Agosto',
	// 		'Setembro',
	// 		'Outubro',
	// 		'Novembro',
	// 		'Dezembro',
	// 	]
	// 	const structuredTasks = [] as any
	// 	this.years.forEach((year) => {
	// 		const tasksInSameYear = this.tasks.filter(
	// 			(deadline) => deadline.date.split('-')[0] === year,
	// 		)

	// 		const tasksInMonths = [] as any
	// 		monthNames.forEach((month, index) => {
	// 			const monthNumber = index + 1
	// 			const tasksInSameYearMonth = tasksInSameYear.filter(
	// 				(deadline) =>
	// 					monthNumber === parseInt(deadline.date.split('-')[1]),
	// 			)

	// 			if (tasksInSameYearMonth.length) {
	// 				tasksInMonths.push({
	// 					month,
	// 					htmlId: genId(),
	// 					deadlines: tasksInSameYearMonth,
	// 				})
	// 			}
	// 		})

	// 		structuredTasks.push({
	// 			year,
	// 			htmlId: genId(),
	// 			months: tasksInMonths,
	// 		})
	// 	})

	// 	return structuredTasks
	// }

	get years() {
		const sortedTasks = [...this.tasks].sort((a, b) => {
			return new Date(a.date).getTime() - new Date(b.date).getTime()
		})

		const uniqueYears = new Set()
		sortedTasks.forEach((task) => {
			uniqueYears.add(task.date.split('-')[0])
		})

		return Array.from(uniqueYears) as string[]
	}

	get structuredTasks() {
		const monthNames = [
			'Janeiro',
			'Fevereiro',
			'Março',
			'Abril',
			'Maio',
			'Junho',
			'Julho',
			'Agosto',
			'Setembro',
			'Outubro',
			'Novembro',
			'Dezembro',
		]

		const sortedTasks = [...this.tasks].sort((a, b) => {
			return new Date(a.date).getTime() - new Date(b.date).getTime()
		})

		const structuredTasks = [] as any

		this.years.forEach((year) => {
			const tasksInSameYear = sortedTasks.filter(
				(deadline) => deadline.date.split('-')[0] === year,
			)

			const tasksInMonths = [] as any
			monthNames.forEach((month, index) => {
				const monthNumber = (index + 1).toString().padStart(2, '0')
				const tasksInSameYearMonth = tasksInSameYear.filter(
					(deadline) => deadline.date.split('-')[1] === monthNumber,
				)

				if (tasksInSameYearMonth.length) {
					tasksInMonths.push({
						month,
						htmlId: genId(),
						deadlines: tasksInSameYearMonth,
					})
				}
			})

			structuredTasks.push({
				year,
				htmlId: genId(),
				months: tasksInMonths,
			})
		})

		return structuredTasks
	}

	getDays(tasks) {
		const uniqueDays = new Set()
		tasks.forEach((task) => {
			// date format = 'YYYY-MM-DD'
			uniqueDays.add(task.date.split('-')[2])
		})

		return uniqueDays
	}

	getTasksInDay(tasks, day) {
		return tasks.filter((task) => task.date.split('-')[2] === day)
	}

	addZeroBefore(numberString) {
		if (numberString.length === 1) {
			return '0' + numberString
		}

		return numberString
	}
}
